import { Upload } from 'antd';
import { MessageDescriptor, useIntl } from 'react-intl';
import { PlusOutlined } from "@ant-design/icons";
import { useCallback, useMemo } from 'react';
import { CustomFile } from '../../pages/Applications/Sunkhronos/tabs/Companies/Company/drawer/createCompany/utils';
import type { UploadProps } from 'antd';

interface Props {
    file?: File | CustomFile;
    beforeUpload: UploadProps['beforeUpload'];
    imageUpload?: boolean; // ✅ marqué comme optionnel
    text: string | MessageDescriptor
}

const UploadButton = ({ file, beforeUpload, imageUpload = false, text }: Props) => {
    const intl = useIntl();

    const renderPreview = useCallback(() => {
        if (!file) return null;

        const url = URL.createObjectURL(file);
        return <img src={url} alt="preview" className="full-width" />;
    }, [file]);

    const uploadButton = useMemo(() => (
        <button style={{ border: 0, background: 'none' }} type="button">
            {imageUpload && file ? (
                renderPreview()
            ) : file ? (
                <div>{file.name}</div>
            ) : (
                <>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>
                        {typeof text === 'string' ? text : intl.formatMessage(text)}
                    </div>
                </>
            )}
        </button>

    ), [file, imageUpload, intl, renderPreview, text]);

    return (
        <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeUpload}
        >
            {uploadButton}
        </Upload>
    );
};

export default UploadButton;
